import React from 'react'
import classnames from 'classnames'
import { inject, observer } from 'mobx-react'
import _ from 'lodash'
import Icon from 'components/common/Icon'
import { getShapePopulationFetchOptions } from '../../../utils'

const getShapeId = (shape) => shape && (shape.id || shape.inner_id || shape.remote_db_id)

const ItemList = ({ uiStore, selectionStore, dataStore, rightSidebarStore, group }) => {
  const totalItemsCount = group.itemsCount
  return (
    totalItemsCount > 0
      ? (
        <ul className='item-list'>
          {
          _.map(group.regions, region => (
            <li
              key={region.inner_id
                ? `boundary_${region.inner_id}`
                : (_.isNil(region.remote_db_id)
                    ? `geopolygon_${region.id.toString()}`
                    : `boundary_${region.remote_db_id.toString()}`)}
              data-group-pk={group.pk}
              data-item-name={region.name}
              data-item-id={region.id != null ? region.id : ''}
              data-inner-id={region.inner_id != null ? region.inner_id : ''}
              data-remote-db-id={region.remote_db_id != null ? region.remote_db_id : ''}
              onMouseDown={(e) => {
                if (e.button !== 0) return
                if (e.target.closest('.three')) return
                const hasCtrlOrShift = e.ctrlKey || e.shiftKey || e.metaKey
                if (hasCtrlOrShift) {
                  selectionStore.addSelectedMenuItem(region)
                } else {
                  selectionStore.setSelectedMenuItem(region)
                }
              }}
              onClick={(e) => {
                if (e.target.closest('.three')) return
                const hasCtrlOrShift = e.ctrlKey || e.shiftKey || e.metaKey
                if (hasCtrlOrShift) {
                  selectionStore.addSelectedMenuItem(region)
                } else {
                  selectionStore.hidePopupMenu()
                  selectionStore.setSelectedMenuItem(region)
                  uiStore.isBarChartActive = true
                  setTimeout(async () => {
                    if (!selectionStore.isEditing) {
                      selectionStore.select(region, { data: { group } })
                      uiStore.setBoundsToItem(region)
                      selectionStore.hideSubTools()
                      // Fetch population/income data for the selected shape.
                      const shapeId = getShapeId(region)
                      if (rightSidebarStore && shapeId) {
                        uiStore.setProcessing(true)
                        await rightSidebarStore.fetchDataForSinglePolygon(
                          shapeId,
                          region.name,
                          getShapePopulationFetchOptions(region)
                        )
                        uiStore.setProcessing(false)
                      }
                    }
                    uiStore.forceRefreshTiles()
                  }, 0)
                }
              }}
              onContextMenu={(e) => {
                e.stopPropagation()
                e.preventDefault()
                if (!selectionStore.selectedMenuItemIds.includes(region.id)) {
                  selectionStore.clearSelectedMenuItems()
                }
                selectionStore.showContextMenu(region, { data: { group } }, e)
              }}
              className={classnames({
                'item-list__item': true,
                selected: uiStore.isItemSelected(region, group)
              })}
              onDragStart={() => {
                uiStore.setDraggableMenuItem(region)
                uiStore.setDraggedMenuItemSourceGroup(group)
              }}
              draggable
            >
              <button type='button' className='item-list__btn' style={{ '--icon-color': region.getColor }}>
                <Icon extraClasses={['item-list__icon']} id={_.isNil(region.remote_db_id) ? 'polygon' : 'hexagon'} />
                <span title={region.name} className='item-list__text'>{_.truncate(region.name, { length: 22 })}</span>
                <Icon
                  id='three-dots'
                  className='three'
                  onMouseDown={(e) => e.stopPropagation()}
                  onClick={(e) => {
                    e.stopPropagation()
                    selectionStore.showPopupMenu(region, { data: { group } }, e)
                  }}
                />
              </button>
            </li>
          ))
        }
          {
          _.map(
            // Show all saved markers belonging to this target group, regardless
            // of whether they are currently assigned to a General/Ally/Competitor
            // bucket. Ungrouped markers will have a white icon in the map and
            // can still be managed from the tools menu.
            group.savedMarkers,
            marker => (
              <li
                key={`marker_${marker.id.toString()}`}
                data-group-pk={group.pk}
                data-item-name={marker.name}
                data-item-id={marker.id != null ? marker.id : ''}
                data-marker-id={marker.id != null ? marker.id : ''}
                onMouseDown={(e) => {
                  if (e.button !== 0) return
                  if (e.target.closest('.three')) return
                  const hasCtrlOrShift = e.ctrlKey || e.shiftKey || e.metaKey
                  if (hasCtrlOrShift) {
                    selectionStore.addSelectedMenuItem(marker)
                  } else {
                    selectionStore.setSelectedMenuItem(marker)
                  }
                }}
                onClick={(e) => {
                  if (e.target.closest('.three')) return
                  const hasCtrlOrShift = e.ctrlKey || e.shiftKey || e.metaKey
                  if (hasCtrlOrShift) {
                    selectionStore.addSelectedMenuItem(marker)
                  } else {
                    selectionStore.hidePopupMenu()
                    selectionStore.setSelectedMenuItem(marker)
                    uiStore.isBarChartActive = true
                    setTimeout(() => {
                      // Clear stale queued map updates from previous selection.
                      if (typeof uiStore.cancelPendingBoundsUpdate === 'function') {
                        uiStore.cancelPendingBoundsUpdate()
                      }
                      if (typeof uiStore.cancelPendingMarkerZoom === 'function') {
                        uiStore.cancelPendingMarkerZoom()
                      }
                      // The selection observer focuses a newly selected POI once.
                      // Clicking this row again keeps the current zoom.
                      selectionStore.select(marker, { data: { group } })
                      selectionStore.hideSubTools()
                      uiStore.forceRefreshTiles()
                    }, 0)
                  }
                }}
                onContextMenu={(e) => {
                  e.stopPropagation()
                  e.preventDefault()
                  if (!selectionStore.selectedMenuItemIds.includes(marker.id)) {
                    selectionStore.clearSelectedMenuItems()
                  }
                  selectionStore.showContextMenu(marker, { data: { group } }, e)
                }}
                className={classnames({
                  'item-list__item': true,
                  selected: uiStore.isItemSelected(marker, group)
                })}
                onDragStart={() => {
                  uiStore.setDraggableMenuItem(marker)
                  uiStore.setDraggedMenuItemSourceGroup(group)
                }}
                draggable
              >
                <button type='button' className='item-list__btn' style={{ '--icon-color': marker.getColor && marker.getColor.active_color }}>
                  <Icon extraClasses={['item-list__icon']} id='map-marker-icon' />
                  <span title={marker.name} className='item-list__text'>{_.truncate(marker.name, { length: 22 })}</span>
                  <Icon
                    id='three-dots'
                    className='three'
                    onMouseDown={(e) => e.stopPropagation()}
                    onClick={(e) => {
                      e.stopPropagation()
                      selectionStore.showPopupMenu(marker, { data: { group } }, e)
                    }}
                  />
                </button>
              </li>
            ))
        }
        </ul>
        )
      : <p className='item-list__empty'>No items</p>
  )
}

export default inject('selectionStore', 'uiStore', 'dataStore', 'rightSidebarStore')(observer(ItemList))
